module.exports = __webpack_public_path__ + "img/arrow_l.7716c305.svg";